import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Agent } from '../models/missingdata.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgentService {

  private Url: string;
  private missingAngents: BehaviorSubject<Agent[]>;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.Url = baseUrl;
    this.missingAngents = new BehaviorSubject<Agent[]>(JSON.parse(localStorage.getItem('missingAngents')));
  }

  public get missingAngentsList(): Agent[] {
    return this.missingAngents.value;
  }

  setAgents(agents: Agent[]) {
    localStorage.setItem('missingAngents', JSON.stringify(agents));
  }

  getAgents() {
    return this.http.get<Agent[]>(this.Url + 'api/agents/')
  }

  saveAgents(agents: Agent[]) {
    return this.http.post(this.Url + 'api/agents/', agents)
  }

  updateAgent(agent: Agent) {
    return this.http.patch(this.Url + 'api/agents/', agent)
  }
}
